import { withInstall } from '@sure-ui/utils'
import Icon from './src/icon.vue'

export const SureIcon = withInstall(Icon)

export default SureIcon

export * from './src/icon'

